import "setimmediate"; // Ensure that polyfills for setImmediate are loaded.

/**
 * Schedules a callback to run as a Task in the event loop.
 *
 * This uses a wrapper around setImmediate from the nodejs event loop,
 * and it ensures the polyfill implementation for web browsers is available.
 */
export function queueTask(task: () => void) {
  setImmediate(task);
}
